
var polarisList = ( function ( $, polarisList ) {
    'use strict';

    var $filterContent;

    // rozpracovaná dávka pro opakování po chybě — sdílí ji hláška nad tabulkou i na jejím konci
    var chunkRetry = null;

    // Generace načítání. Když uživatel přepne stránku nebo limit ještě během dotahování dávek,
    // starý řetěz musí skončit — jinak by dosypával řádky předchozí stránky do nové tabulky.
    var chunkGeneration = 0;

    polarisList.filter = function()
    {
        $filterContent = $('[data-filter-content]');

        $(document).on('click', '.Polaris-Backdrop--transparent', function(ev) {
            ev.preventDefault();
            $('[data-filter-close-btn]').click();
        });

        $(document).on('click', '[data-filter-close-btn]', function(ev) {
            ev.preventDefault();
            $('[data-filter-content]').hide();
        });

        if($('.filter-group-hidden').length){
            $('[data-filter-show-hidden-btn]').show();
        }

        $(document).on('click', '[data-filter-show-hidden-btn]', function(ev) {
            ev.preventDefault();
            let $button = $(ev.currentTarget);
            let type = '';
            if($button.hasClass('opened')){
                type = 'close';
                $button.removeClass('opened');
                $(this).text($(this).data('textOpen'));
            } else {
                type = 'open';
                $button.addClass('opened');
                $(this).text($(this).data('textClose'));
            }
            $('.filter-group-hidden [data-filter-group-label]').trigger('click', [type]);
        });

        $(document).on('click', '[data-filter-group-label]', function(ev, type) {
            const button = $(this);
            const open = button.data('filterGroupLabel') === 'open';
            const $itemContent = $(this).closest('[data-filter-group-content]');
            const $content = $itemContent.children('[data-filter-group-label-content]').first();

            if ((type === 'open' && open) || (type === 'close' && !open)) {
                return;
            }

            button.data('filterGroupLabel', open ? 'close' : 'open');

            $content.slideToggle();
            if(button.closest('.filter-group-hidden').length){
                return;
            }
            button.find('[data-filter-item-icon-down]').toggle();
            button.find('[data-filter-item-icon-up]').toggle();
        });

        $(document).on('click', '[data-filter-item-label]', function(ev) {
            ev.preventDefault();
            var $itemContent = $(this).closest('[data-filter-item-content]');
            var $elementsContent = $itemContent.find('[data-filter-item-element-content]');
            var $elementContent = $elementsContent.find('[data-ajax-filter-element-url]');

            let ajaxUrlElement = $elementContent.data('ajax-filter-element-url');

            // open with ajax
            if (ajaxUrlElement) {

                $elementContent.html(' <img width="15" height="15" src="/images/ajax-loader.gif" />');
                $elementsContent.slideToggle();
                $itemContent.find('[data-filter-item-icon-down]').toggle();
                $itemContent.find('[data-filter-item-icon-up]').toggle();

                $.ajax({
                    url: ajaxUrlElement,
                    success: function(data) {
                        $elementContent.data('ajax-filter-element-url', null);
                        $elementContent.html(data.html);

                        window.chosenLoad();
                        window.select2Init();
                    }
                });
            } else {
                $elementsContent.slideToggle();
                $itemContent.find('[data-filter-item-icon-down]').toggle();
                $itemContent.find('[data-filter-item-icon-up]').toggle();
            }
        });

        $(document).on('click', '[data-filter-btn]', function(ev) {
            ev.preventDefault();
            $('[data-filter-content]').show();
        });

        $(document).on('click', '[data-search-btn]', function(ev) {
            ev.preventDefault();
            $('.datagrid-search-btn').hide();
            $('.datagrid-search-input').show();
            $('.datagrid-search-input input').focus();
        });

        $(document).on('keypress', '[data-search-input]', function(ev) {
            if (ev.which === 13) {
                let filter = $('[data-list-filter]');
                filter.find('input[name="fulltext"]').val($(this).val());
                filter.submit();
            }
        })

        $(document).on('click', '[data-filter-multiple-select-all]', function() {
            var $row = $(this).closest('[data-filter-item-content]');
            if ($row.is('.active')) {
                $row.removeClass('active');
            }
            else {
                $row.addClass('active');
            }
            $row.find('option').prop('selected', $row.is('.active')).parent().trigger('chosen:updated');
        });
    };

    polarisList.clearSelectMemmory = function() {
        var $headerSelect = $('[data-index-select-header]');
        $headerSelect.data('values', {});
    };

    polarisList.showSelectControlPanel = function() {
        var $headerSelect = $('[data-index-select-header]');
        var $headerNoSelect = $('[data-index-no-select-header]');
        var data = $headerSelect.data('values');

        // zobrazíme dle toho jestli jsou nějaké řádky označené
        if (Object.keys(data).length) {
            $headerSelect.show();
            // $headerNoSelect.hide();
            $headerNoSelect.closest('.Polaris-IndexTable').find('.Polaris-IndexTable__Table').addClass('Polaris-IndexTable--selectMode');

            var count = 0;
            $.each(data, function(key, values) {
                count = count + Object.keys(values).length;
            });
            $headerSelect.find('.Polaris-CheckableButton__Label span').text(count);
        }
        else {
            $headerSelect.hide();
            // $headerNoSelect.show();
            $headerNoSelect.closest('.Polaris-IndexTable').find('.Polaris-IndexTable__Table').removeClass('Polaris-IndexTable--selectMode');
        }
    };

    // pro uložení mezi stránkama ukládáme do localstorage následně načteme pomocí polarisList.loadSelectedRows
    polarisList.saveSelectedRows = function() {
        var $headerSelect = $('[data-index-select-header]');
        // pokud neexistuji data z předchozí stránky, tak vytvoříme prázný object
        if (typeof $headerSelect.data('values') !== "undefined") {
            window.localStorage.setItem('select-values', JSON.stringify($headerSelect.data('values')));
        }
    };

    polarisList.loadSelectedRows = function() {
        // pokud máme něco v LocalStorage, tak zobrazíme a odstraníme z localstorege
        var $headerSelect = $('[data-index-select-header]');
        var $selectValue = window.localStorage.getItem('select-values');
        if ($selectValue) {
            var data = JSON.parse($selectValue);
            $headerSelect.data('values', data);
            polarisList.showSelectControlPanel();

            $('.Polaris-IndexTable__TableRow--selected').removeClass('Polaris-IndexTable__TableRow--selected');
            // pokud jsou uložené i data na stránce tak checkboxy nastavíme na checked
            $.each(data, function(key, values) {
                $.each(values, function(k, k2) {
                    $('[data-index-select-checkbox-item][name="' + key + '"][value="' + k2 + '"]').prop('checked', true).closest('tr').addClass('Polaris-IndexTable__TableRow--selected');
                });
            });

            window.localStorage.removeItem('select-values')
        }
    };

    // Doznačí řádky vložené další dávkou. loadSelectedRows() čte localStorage a po přečtení ji maže,
    // takže pro dávky 2..N je zdrojem pravdy už jen to, co drží hlavička v paměti.
    polarisList.markSelectedRows = function() {
        var data = $('[data-index-select-header]').data('values');
        if (!data) {
            return;
        }

        $.each(data, function(key, values) {
            $.each(values, function(k, k2) {
                $('[data-index-select-checkbox-item][name="' + key + '"][value="' + k2 + '"]')
                    .prop('checked', true)
                    .closest('tr').addClass('Polaris-IndexTable__TableRow--selected');
            });
        });
    };

    polarisList.checkSelectedRow = function() {
        var $selectedRow = $('[data-index-select-checkbox-item]:checked');
        var $noSelectedRow = $('[data-index-select-checkbox-item]:not(:checked)');
        var $headerNoSelect = $('[data-index-no-select-header]');
        var $headerSelect = $('[data-index-select-header]');

        // pokud neexistuji data z předchozí stránky, tak vytvoříme prázný object
        if (typeof $headerSelect.data('values') === "undefined") {
            $headerSelect.data('values', {});
        }

        var data = $headerSelect.data('values');

        $('.Polaris-IndexTable__TableRow--selected').removeClass('Polaris-IndexTable__TableRow--selected');

        // ty které jsou selected, přidáme do pole
        $selectedRow.each(function(i, el) {
            var $el = $(el);
            if (typeof data[$el.attr('name')] === 'undefined') {
                data[$el.attr('name')] = {};
            }
            data[$el.attr('name')][$el.val()] = $el.val();

            $el.closest('tr').addClass('Polaris-IndexTable__TableRow--selected');
        });


        // ty které nejsou na stránce selected odebereme z pole
        $noSelectedRow.each(function(i, el) {
            var $el = $(el);

            if (typeof data[$el.attr('name')] === "undefined") {

            }
            else if (typeof data[$el.attr('name')][$el.val()] !== "undefined") {
                delete data[$el.attr('name')][$el.val()];
            }
            else if (Object.keys(data[$el.attr('name')]).length === 0) {
                delete data[$el.attr('name')];
            }
        });


        // nastavíme data k hromadným akcím
        $('[data-index-select-action-item] [data-action-type]').each(function(i, el) {
            var $el = $(el);
            if ($el.data('action-type') === 'modal') {
                $el.data('values', data);
            }
        });

        // uložíme si, abychom mohl v případě stránkování uchovat ID produktu
        $headerSelect.data('values', data);

        // pokud jsou nějaké selected, tak zobrazíme panel
        polarisList.showSelectControlPanel();
    };

    polarisList.lazyLoadContent = function(url) {
        var $scrollContainer = $('[data-datagrid-lazy-url]').find('.Polaris-IndexTable-ScrollContainer');
        var $tbody = $scrollContainer.find('tbody');

        // overlay přes tabulku s loaderem — zachová výšku obsahu
        if ($tbody.length && $tbody.find('tr').length > 0 && !$tbody.is('[data-datagrid-lazy-body]')) {
            $scrollContainer.css('position', 'relative');
            $scrollContainer.append(
                '<div data-datagrid-lazy-overlay style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.7);display:flex;align-items:center;justify-content:center;z-index:10;">' +
                    '<img src="/images/ajax-loader.gif" width="24" height="24" />' +
                '</div>'
            );
        }

        chunkGeneration++;
        polarisList.loadDataChunk(url, 0, 0, $scrollContainer, chunkGeneration);
    };

    // Načte jednu dávku řádků a řetězí se na další. Velká stránka (1000 řádků) se tak přenese jako
    // 10 krátkých requestů místo jednoho dlouhého, který na velkém katalogu končil na 504 (TRAN-3136).
    // Dávky jdou sekvenčně — drží pořadí řádků a nezatíží DB paralelními dotazy.
    polarisList.loadDataChunk = function(url, chunkIndex, loadedRows, $scrollContainer, generation) {
        var chunkUrl = new URL(url, window.location.origin);
        chunkUrl.searchParams.set('__chunk', chunkIndex);

        if (typeof generation === 'undefined') {
            generation = chunkGeneration;
        }

        $.ajax({
            url: chunkUrl.toString(),
            success: function(data) {
                // mezitím se načítá jiná stránka — tuhle odpověď už do tabulky nepatří
                if (generation !== chunkGeneration) {
                    return;
                }

                $('[data-datagrid-lazy-overlay]').remove();
                polarisList.clearChunkStatus($scrollContainer);

                if (!data || data.status === 'error' || !data.bodyHtml) {
                    polarisList.showChunkError(url, chunkIndex, loadedRows, $scrollContainer);
                    return;
                }

                if (chunkIndex === 0) {
                    // najdeme tbody znovu (mohl být nahrazen předchozím lazy loadem)
                    $scrollContainer.find('tbody').replaceWith(data.bodyHtml);

                    if (data.footerHtml) {
                        $('[data-datagrid-lazy-footer]').html(data.footerHtml);
                    }

                    // AJAX paginace — odchytíme kliky na stránkovací linky
                    polarisList.bindLazyPagination();
                } else {
                    // z odpovědi vezmeme jen řádky, tbody v tabulce zůstává
                    $scrollContainer.find('tbody').append($(data.bodyHtml).children());
                }

                loadedRows += (data.rowCount || 0);

                // znovu navážeme event handlery pro nově vložené řádky
                $('[data-index-select-checkbox-item]').off('change').on('change', function() {
                    polarisList.checkSelectedRow();
                });
                if (chunkIndex === 0) {
                    polarisList.loadSelectedRows();
                } else {
                    // localStorage už je vyčtená z první dávky, označení se bere z paměti hlavičky
                    polarisList.markSelectedRows();
                }

                // reinicializace `data-load-number` pro nově vložené řádky
                if (typeof window.initDataLoadNumber === 'function') {
                    window.initDataLoadNumber($scrollContainer);
                }

                // nově vložené řádky obsahují <img class="lazyload" data-src> — znovu navázat lazyload swap
                if (typeof window.activeLazyload === 'function') {
                    window.activeLazyload();
                }

                // poslední stránka bývá neúplná — nemá smysl dotahovat dávky, ve kterých už nic není
                var chunkCount = data.chunkCount || 1;
                var rowsOnPage = data.rowsOnPage || 0;
                if (chunkIndex + 1 < chunkCount && loadedRows < rowsOnPage) {
                    polarisList.showChunkProgress($scrollContainer, loadedRows, rowsOnPage);
                    polarisList.loadDataChunk(url, chunkIndex + 1, loadedRows, $scrollContainer, generation);
                }
            },
            error: function() {
                if (generation !== chunkGeneration) {
                    return;
                }

                $('[data-datagrid-lazy-overlay]').remove();
                polarisList.clearChunkStatus($scrollContainer);
                polarisList.showChunkError(url, chunkIndex, loadedRows, $scrollContainer);
            }
        });
    };

    polarisList.clearChunkStatus = function($scrollContainer) {
        $('[data-datagrid-chunk-status-top]').hide().empty();
        $scrollContainer.find('[data-datagrid-chunk-status]').remove();
    };

    // Stav dávkového načítání se vypisuje na dvě místa: do plovoucí hlášky pod horní lištou
    // (uživatel odscrollovaný nahoru řádek na konci tabulky nevidí) a na konec tabulky, kde
    // řádky přitékají. Hláška je tmavá pilulka, řádek tabulky světlý — proto dva HTML kusy.
    polarisList.setChunkStatus = function($scrollContainer, topHtml, rowHtml, isError) {
        var colCount = $scrollContainer.find('thead th').length || 1;

        $('[data-datagrid-chunk-status-top]')
            .html(topHtml)
            .css('background', isError ? '#d72c0d' : '#1a1a1a')
            .show();

        $scrollContainer.find('[data-datagrid-chunk-status]').remove();
        $scrollContainer.find('tbody').append(
            '<tr data-datagrid-chunk-status><td colspan="' + colCount + '" style="text-align:center;padding:12px;' +
                (isError ? 'color:#d72c0d;' : '') + '">' + rowHtml + '</td></tr>'
        );
    };

    polarisList.showChunkProgress = function($scrollContainer, loadedRows, rowsOnPage) {
        var translator = new I18n;
        var label = translator.trans('javascript.datagrid-chunk-loading', {loaded: loadedRows, total: rowsOnPage});
        var html = '<img src="/images/ajax-loader.gif" width="16" height="16" /> ' + label;

        polarisList.setChunkStatus($scrollContainer, html, html, false);
    };

    // Selhala dávka: první dávka = tabulka je prázdná, takže původní hláška; další dávky = už načtené
    // řádky si necháme a nabídneme dotažení zbytku, ať uživatel nepřijde o to, co vidí.
    polarisList.showChunkError = function(url, chunkIndex, loadedRows, $scrollContainer) {
        var translator = new I18n;

        if (chunkIndex === 0) {
            var colCount = $scrollContainer.find('thead th').length || 1;
            $scrollContainer.find('tbody').html(
                '<tr><td colspan="' + colCount + '" style="text-align:center;padding:20px;color:red;">' +
                    translator.trans('javascript.datagrid-load-failed') +
                '</td></tr>'
            );
            return;
        }

        chunkRetry = {url: url, chunkIndex: chunkIndex, loadedRows: loadedRows, $scrollContainer: $scrollContainer};

        var text = translator.trans('javascript.datagrid-chunk-failed');
        var retryLabel = translator.trans('javascript.datagrid-chunk-retry');

        polarisList.setChunkStatus(
            $scrollContainer,
            text + ' <a href="#" data-datagrid-chunk-retry style="color:#fff;text-decoration:underline;">' + retryLabel + '</a>',
            text + ' <a href="#" data-datagrid-chunk-retry>' + retryLabel + '</a>',
            true
        );
    };

    // Opakování selhané dávky — odkaz je nad tabulkou i na jejím konci, proto delegovaně na document.
    polarisList.bindChunkRetry = function() {
        $(document).off('click.datagridChunkRetry', '[data-datagrid-chunk-retry]')
            .on('click.datagridChunkRetry', '[data-datagrid-chunk-retry]', function(ev) {
                ev.preventDefault();

                if (chunkRetry === null) {
                    return;
                }

                var retry = chunkRetry;
                chunkRetry = null;

                polarisList.clearChunkStatus(retry.$scrollContainer);
                polarisList.loadDataChunk(retry.url, retry.chunkIndex, retry.loadedRows, retry.$scrollContainer, chunkGeneration);
            });
    };

    polarisList.bindLazyPagination = function() {
        // paginace — linky jsou <a class="Polaris-Button" href="...">
        $('[data-datagrid-lazy-footer]').off('click', 'a.Polaris-Button').on('click', 'a.Polaris-Button', function(ev) {
            ev.preventDefault();
            var href = $(this).attr('href');
            if (!href) return;

            // přidáme __lazy_load do AJAX URL
            var ajaxUrl = new URL(href, window.location.origin);
            ajaxUrl.searchParams.set('__lazy_load', '1');

            // aktualizujeme URL v prohlížeči bez __lazy_load
            window.history.pushState({}, '', href);

            polarisList.saveSelectedRows();
            polarisList.lazyLoadContent(ajaxUrl.toString());
        });

        // změna limitu na stránku
        $('[data-datagrid-lazy-footer]').off('click', '[data-list-page-limit]').on('click', '[data-list-page-limit]', function(ev) {
            ev.preventDefault();
            var url = new URL(window.location.href);
            url.searchParams.set('limit', $(this).attr('data-list-page-limit'));
            url.searchParams.delete('page');

            var ajaxUrl = new URL(url.toString());
            ajaxUrl.searchParams.set('__lazy_load', '1');

            window.history.pushState({}, '', url.toString());

            polarisList.saveSelectedRows();
            polarisList.lazyLoadContent(ajaxUrl.toString());
        });
    };

    polarisList.lazyLoad = function() {
        var $wrapper = $('[data-datagrid-lazy-url]');
        if (!$wrapper.length) {
            return;
        }

        polarisList.lazyLoadContent($wrapper.data('datagrid-lazy-url'));
    };

    // Menu akcí v řádku (DataGrid::rowActionUrl) — v tabulce je jen ovladač, obsah menu se dotáhne
    // AJAXem při prvním kliknutí. U 1000 řádků tvořilo menu většinu HTML stránky (TRAN-3136).
    // Delegováno na document, aby fungovalo i po lazy výměně tbody.
    polarisList.rowActions = function() {
        $(document).off('click.datagridRowActions', '[data-datagrid-row-actions-url]')
            .on('click.datagridRowActions', '[data-datagrid-row-actions-url]', function(ev) {
                ev.preventDefault();
                var $trigger = $(this);

                if ($trigger.data('loading')) {
                    return;
                }
                $trigger.data('loading', true);

                var translator = new I18n;
                var $cell = $trigger.closest('td');
                var $icon = $trigger.find('i');
                var iconClass = $icon.attr('class');
                $icon.attr('class', 'fas fa-spinner fa-spin');

                var fail = function() {
                    $trigger.data('loading', false);
                    $icon.attr('class', iconClass);
                    window.alert(translator.trans('javascript.datagrid-row-actions-load-failed'));
                };

                $.ajax({
                    url: $trigger.data('datagrid-row-actions-url'),
                    success: function(data) {
                        if (!data || data.status === 'error' || !data.html) {
                            fail();
                            return;
                        }

                        // ovladač se vymění za celé menu, takže loading flag už není potřeba resetovat
                        $cell.html(data.html);
                        $cell.find('[data-toggle="dropdown"]').dropdown('toggle');

                        if (typeof window.tooltipStart === 'function') {
                            window.tooltipStart();
                        }
                    },
                    error: fail
                });
            });
    };

    // Rozbalovací řádky datagridu (DataGrid::rowExpandUrl) — toggle + lazy-load obsahu pod řádkem.
    // Delegováno na document, aby fungovalo i po lazy výměně tbody.
    polarisList.expandableRows = function() {
        $(document).off('click.datagridExpand', '[data-datagrid-expand-toggle]')
            .on('click.datagridExpand', '[data-datagrid-expand-toggle]', function(ev) {
                ev.preventDefault();
                var $toggle = $(this);
                var $row = $toggle.closest('tr');
                var $detailRow = $row.next('[data-datagrid-expand-row]');
                if (!$detailRow.length) {
                    return;
                }

                var $content = $detailRow.find('[data-datagrid-expand-content]');
                var isOpen = $detailRow.is(':visible');

                if (isOpen) {
                    $detailRow.hide();
                    $toggle.removeClass('is-open');
                    $toggle.find('.datagrid-expand-toggle-label').text($toggle.data('labelOpen'));
                    return;
                }

                $detailRow.show();
                $toggle.addClass('is-open');
                $toggle.find('.datagrid-expand-toggle-label').text($toggle.data('labelClose'));

                if ($content.data('loaded')) {
                    return;
                }

                $content.html('<div style="padding:20px;text-align:center;"><img src="/images/ajax-loader.gif" width="24" height="24" /></div>');

                var translator = new I18n;

                $.ajax({
                    url: $content.data('url'),
                    type: 'GET',
                    success: function(data) {
                        if (data && data.status === 'error') {
                            $content.html('<div class="Polaris-Banner Polaris-Banner--statusCritical" style="padding:12px;">' + (data.message || translator.trans('javascript.datagrid-detail-load-error')) + '</div>');
                            return;
                        }
                        $content.html(data.html);
                        $content.data('loaded', true);
                        if (typeof window.tooltipStart === 'function') {
                            window.tooltipStart();
                        }
                    },
                    error: function() {
                        $content.html('<div class="Polaris-Banner Polaris-Banner--statusCritical" style="padding:12px;">' + translator.trans('javascript.datagrid-detail-load-failed') + '</div>');
                    }
                });
            });
    };

    // Schválení / zamítnutí návrhu z auditu. Buttony se lazy-loadují do expand řádku,
    // proto delegujeme na document. Po úspěchu vyměníme HTML detailu za re-render z odpovědi.
    polarisList.auditApproval = function() {
        $(document).off('click.auditApproval', '[data-audit-approve], [data-audit-reject]')
            .on('click.auditApproval', '[data-audit-approve], [data-audit-reject]', function(ev) {
                ev.preventDefault();
                var $btn = $(this);
                if ($btn.prop('disabled')) {
                    return;
                }

                var url = $btn.data('url');
                if (!url) {
                    return;
                }

                var $container = $btn.closest('[data-audit-detail-content]');

                // vynechané věty opravy (fáze 12) jdou jen se schválením — zamítnutí bere celý návrh
                var rejectedUnits = $btn.is('[data-audit-approve]') ? polarisList.auditRejectedUnits($container) : [];

                // placené schválení opravy (TRAN-3276) se potvrzuje v modalu jako „Schválit vše";
                // tlačítko v patičce modalu pak pošle stejný AJAX jako dřív (detail se překreslí)
                if ($btn.data('confirmUrl') && typeof window.loadModal === 'function') {
                    polarisList.auditPendingApproval = { $btn: $btn, rejectedUnits: rejectedUnits };
                    window.loadModal($btn.data('confirmUrl'), { rejected_units: rejectedUnits.length });
                    return;
                }

                var confirmMsg = $btn.data('confirm');
                if (rejectedUnits.length && $btn.data('confirmPartial')) {
                    confirmMsg = String($btn.data('confirmPartial')).replace(':count', rejectedUnits.length);
                }
                if (confirmMsg && !window.confirm(confirmMsg)) {
                    return;
                }

                polarisList.auditSendDecision($btn, rejectedUnits);
            });

        $(document).off('click.auditApprovalSubmit', '[data-audit-approve-submit]')
            .on('click.auditApprovalSubmit', '[data-audit-approve-submit]', function(ev) {
                ev.preventDefault();
                var pending = polarisList.auditPendingApproval;
                polarisList.auditPendingApproval = null;
                $('.action-modal').modal('hide');
                if (pending) {
                    polarisList.auditSendDecision(pending.$btn, pending.rejectedUnits);
                }
            });
    };

    // Odeslání rozhodnutí (schválit / zamítnout) a výměna detailu za re-render z odpovědi.
    polarisList.auditSendDecision = function($btn, rejectedUnits) {
        var url = $btn.data('url');
        var $container = $btn.closest('[data-audit-detail-content]');
        var $footer = $btn.closest('[data-audit-footer]');
        $footer.find('button').prop('disabled', true);

        $.ajax({
            url: url,
            type: 'POST',
            data: rejectedUnits.length ? { rejected_units: rejectedUnits } : {},
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            success: function(data) {
                if (data && data.status === 'error') {
                    window.alert(data.message || $btn.data('error'));
                    $footer.find('button').prop('disabled', false);
                    return;
                }
                if (data && data.html) {
                    // řádek gridu zapamatovat PŘED výměnou detailu (container se odpojí)
                    var $row = $container.closest('[data-datagrid-expand-row]').prev('tr');
                    $container.replaceWith(data.html);
                    // živá aktualizace buňky „Schválení" v řádku (bez reloadu)
                    if (data.approvalBadge && $row.length) {
                        $row.find('[data-audit-row-approval]').html(data.approvalBadge);
                    }
                    if (typeof window.tooltipStart === 'function') {
                        window.tooltipStart();
                    }
                }
            },
            error: function() {
                window.alert($btn.data('error'));
                $footer.find('button').prop('disabled', false);
            }
        });
    };

    // Doběhlá oprava textů (TRAN-3198): server pošle websocket zprávu `auditRepairDone` s id auditů.
    // Otevřený detail s běžící opravou (`data-audit-repair-pending`) se načte znovu a ukáže návrh,
    // badge v řádku (`data-audit-row-approval`) se přepne ze „Čeká na opravu textů". Bez websocketu
    // se nic nerozbije — detail ukáže návrh po znovuotevření.
    polarisList.auditRepairLive = function() {
        // bez kontroly DOM: řádky gridu se načítají líně, při inicializaci ještě nemusí být na stránce
        if (polarisList.auditRepairLiveBound || !window.app || !window.app.webSocket) {
            return;
        }
        polarisList.auditRepairLiveBound = true;

        window.app.webSocket.bind('auditRepairDone', function(data) {
            var auditIds = [];
            try {
                auditIds = JSON.parse(data.message).auditIds || [];
            } catch (e) {
                return;
            }

            auditIds.forEach(function(auditId) {
                var $pending = $('[data-audit-repair-pending="' + auditId + '"]');
                var $badge = $('[data-audit-row-approval][data-audit-id="' + auditId + '"]');
                var url = $pending.attr('data-url') || $badge.attr('data-url');
                if (!url) {
                    return;
                }

                $.get(url, function(response) {
                    if (!response || response.status !== 'success') {
                        return;
                    }
                    if ($pending.length && response.html) {
                        $pending.closest('[data-audit-detail-content]').replaceWith(response.html);
                        if (typeof window.tooltipStart === 'function') {
                            window.tooltipStart();
                        }
                    }
                    if ($badge.length && typeof response.approvalBadge !== 'undefined') {
                        $badge.html(response.approvalBadge);
                    }
                });
            });
        });
    };

    // Vynechání věty z opravy (TRAN-3276, fáze 12). Zvýrazněné úseky opravy nesou `data-audit-unit`
    // (věta), položky „Co jsme opravili" `data-audit-unit-item` a tlačítko `data-audit-unit-toggle`.
    // Klik kamkoli z toho vyřadí / vrátí celou větu; schválení pak pošle seznam vyřazených.
    polarisList.auditRejectedUnits = function($container) {
        var units = [];
        $container.find('[data-audit-units] .is-rejected[data-audit-unit], [data-audit-units] .is-rejected[data-audit-unit-item]').each(function() {
            var unit = $(this).attr('data-audit-unit') || $(this).attr('data-audit-unit-item');
            if (units.indexOf(unit) === -1) {
                units.push(unit);
            }
        });
        return units;
    };

    polarisList.auditUnits = function() {
        var unitSelector = function(unit) {
            var escaped = String(unit).replace(/"/g, '\\"');
            return '[data-audit-unit="' + escaped + '"], [data-audit-unit-item="' + escaped + '"]';
        };

        var updateSummary = function($container) {
            var count = polarisList.auditRejectedUnits($container).length;
            $container.find('[data-audit-unit-summary]').each(function() {
                var $summary = $(this);
                $summary.toggleClass('is-active', count > 0);
                $summary.text(count > 0
                    ? polarisList.auditChoice(String($summary.data('labelSome')), count)
                    : $summary.data('labelNone'));
            });
        };

        $(document).off('click.auditUnits')
            .on('click.auditUnits', '[data-audit-units] .audit-unit[data-audit-unit], [data-audit-units] [data-audit-unit-toggle]', function(ev) {
                ev.preventDefault();
                var $el = $(this);
                var unit = $el.attr('data-audit-unit') || $el.attr('data-audit-unit-toggle');
                var $row = $el.closest('[data-audit-units]');
                var $container = $el.closest('[data-audit-detail-content]');
                var $parts = $row.find(unitSelector(unit));
                var rejected = !$parts.first().hasClass('is-rejected');

                $parts.toggleClass('is-rejected', rejected);
                $row.find('[data-audit-unit-toggle="' + unit + '"]').each(function() {
                    $(this).text(rejected ? $(this).data('labelRestore') : $(this).data('labelReject'));
                });
                updateSummary($container);
            })
            .on('mouseenter.auditUnits mouseleave.auditUnits', '[data-audit-units] .audit-unit[data-audit-unit], [data-audit-units] [data-audit-unit-item]', function(ev) {
                var $el = $(this);
                var unit = $el.attr('data-audit-unit') || $el.attr('data-audit-unit-item');
                $el.closest('[data-audit-units]').find(unitSelector(unit)).toggleClass('is-hover', ev.type === 'mouseenter');
            });
    };

    // Laravel trans_choice pro JS: „{1} …|[2,4] …|[5,*] …" — vybere variantu podle počtu.
    polarisList.auditChoice = function(text, count) {
        var parts = text.split('|');
        for (var i = 0; i < parts.length; i++) {
            var match = parts[i].match(/^\s*(\{(\d+)\}|\[(\d+),(\d+|\*)\])\s*(.*)$/);
            if (!match) {
                continue;
            }
            var ok = match[2] !== undefined
                ? count === parseInt(match[2], 10)
                : count >= parseInt(match[3], 10) && (match[4] === '*' || count <= parseInt(match[4], 10));
            if (ok) {
                return match[5].replace(':count', count);
            }
        }
        return parts[parts.length - 1].replace(/^\s*(\{\d+\}|\[[^\]]+\])\s*/, '').replace(':count', count);
    };

    polarisList.initialize = function()
    {
        polarisList.filter();
        polarisList.rowActions();
        polarisList.bindChunkRetry();
        polarisList.expandableRows();
        polarisList.auditApproval();
        polarisList.auditUnits();
        polarisList.auditRepairLive();

        $('[data-list-page-limit]').on('click', function(e) {
            var url = new URL(window.location.href);
            url.searchParams.set('limit', $(this).attr('data-list-page-limit'));
            window.location.href = url.href;
        });

        // klik na checkbox na řádku
        $('[data-index-select-checkbox-item]').on('change', function() {
            polarisList.checkSelectedRow();
        });

        var $jobsContent = $('[data-jobs-content]');
        if ($jobsContent.length) {
            var checkJobs = function() {
                var isDropdownOpen = $('[data-datagrid-job-dropdown]').is('.show');

                $.ajax({
                    url: $jobsContent.data('jobs-url'),
                    success: function(data) {
                        if (data.html) {
                            $jobsContent.html(data.html);
                            if (isDropdownOpen) {
                                $('[data-datagrid-job-btn]').click();
                            }
                        } else {
                            $jobsContent.html('');
                            clearInterval(jobInterval);
                        }
                    }
                });
            };
            var jobInterval = setInterval(checkJobs, 5000);
        }

        // klik na checkbox v hlavičce (označut vše)
        $('[data-index-select-checkbox-all]').on('change', function() {
            $('[data-index-select-checkbox-item]').prop('checked', true);
            $(this).prop('checked', false);
            polarisList.checkSelectedRow();
        });

        // click na selected checkbox v hlavičce (zrušit označené)
        $('[data-index-select-selected-content]').on('click', function() {
            $('[data-index-select-checkbox-item]').prop('checked', false);
            polarisList.clearSelectMemmory();
            polarisList.checkSelectedRow();
        });

        // click na selected checkbox v hlavičce (zrušit označené)
        $('[data-index-select-all-content] button').on('click', function(ev) {
            ev.preventDefault();
            var $this = $(this);
            var $headerSelect = $('[data-index-select-header]');

            // Disable button and add loader
            $this.prop('disabled', true);
            $this.addClass('Polaris-Button--disabled');

            // Check if loading icon already exists
            if (!$this.find('.button-loading-icon').length) {
                $this.append(' <img class="button-loading-icon" width="16" height="16" src="/images/ajax-loader.gif" style="margin-left: 8px; vertical-align: middle;" />');
            }

            $.ajax({
                url: $this.data('index-select-all-url'),
                timeout: 60000, // 60 seconds timeout
                success: function(data) {
                    $headerSelect.data('values', data.result);
                    $headerSelect.find('.Polaris-CheckableButton__Label span').text(data.count);
                    $('[data-index-select-checkbox-item]').prop('checked', true);
                    $('[data-index-select-action-item] [data-action-type]').each(function(i, el) {
                        var $el = $(el);
                        if ($el.data('action-type') === 'modal') {
                            $el.data('values', data.result);
                        }
                    });
                },
                error: function(xhr, status, error) {
                    // Show error message
                    var errorMessage = 'Error to load items.';
                    if (status === 'timeout') {
                        errorMessage = 'Timeout 60s';
                    } else if (xhr.responseJSON && xhr.responseJSON.message) {
                        errorMessage = xhr.responseJSON.message;
                    }
                    alert(errorMessage);
                },
                complete: function() {
                    // Re-enable button and remove loader (called always - success or error)
                    $this.prop('disabled', false);
                    $this.removeClass('Polaris-Button--disabled');
                    $this.find('.button-loading-icon').remove();
                }
            });
        });

        $('.page-link, [data-list-page-limit]').on('click', function() {
            polarisList.saveSelectedRows();
        });
        polarisList.loadSelectedRows();

        // pokud existují checkboxy, tak pošleme požadavek na všechny položky a necháme uložit do cache
        if ($('[data-index-select-all-url]').length) {
            $.ajax({
                url: $('[data-index-select-all-url]').data('index-select-all-url'),
                success: function(data) {

                }
            });
        }

        // lazy loading dat datagridu
        polarisList.lazyLoad();
    };

    return polarisList;
}( window.jQuery, polarisList || { } ) );

window.polarisList = polarisList;

$(document).ready(function() {
    let hash = window.location.hash ? window.location.hash.replace('#', '') : '';
    switch(hash) {
        case 'translated':
            window.setTimeout(function() {
                selectAllProducts(translateAll);
            }, 500);
            break;
        case 'rated':
            window.setTimeout(function() {
                selectAllProducts(rateAll);
            }, 500);
            break;
        case 'exported':
            window.setTimeout(function() {
                selectAllProducts(exportAll);
            }, 500);
            break;

    }

    function selectAllProducts(next) {
        $('[data-index-no-select-header] input[name="select-all"]').trigger('click');
        window.setTimeout(function() {
            $('[data-index-select-all-url]').trigger('click');
            window.setTimeout(next, 1000);
        }, 500);
    }

    function translateAll() {
        $('[data-index-select-header] a[href*="product\/translate"]:first').trigger('click');
    }

    function rateAll() {
        $('[data-index-select-header] a[href*="translation-quality"]:first').trigger('click');
    }

    function exportAll() {
        $('[data-index-select-header] a[href*="product\/listed"]:first').trigger('click');
    }
});
